import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ActivityImageValue } from '@/types/upload';

interface ActivityImagePreviewProps {
  value: ActivityImageValue;
  onRemove: () => void;
}

function typeLabel(type: ActivityImageValue['type']): string {
  if (type === 'custom') return 'Showing custom image';
  if (type === 'category') return 'Showing category image';
  return 'Showing predefined image';
}

export default function ActivityImagePreview({ value, onRemove }: ActivityImagePreviewProps) {
  return (
    <div className="relative">
      <img
        src={value.viewUrl}
        alt="Activity"
        className="w-full aspect-[382/197] object-cover rounded-md border border-admin-slate-300/20"
      />
      <div className="absolute top-2 right-2">
        <Button type="button" variant="destructive" size="sm" onClick={onRemove}>
          <X className="h-4 w-4 mr-1" />
          Remove
        </Button>
      </div>
      <div className="mt-1 text-xs text-admin-slate-500">
        {typeLabel(value.type)}
      </div>
    </div>
  );
}
